import { OverviewCard } from "../components/card/overview";
import { CountChart } from "../components/charts/count-chart";
import { WeeklyPostChart } from "../components/charts/weekly-posts-chart";
import { FinanceChart } from "../components/charts/finance-chart";
import { Activity } from "../components/activity/activity";
import { useQuery } from "@tanstack/react-query";
import { getUserCount } from "../services/userService";
import { getPostCount } from "../services/postService";
import { getApplicationCount } from "../services/applicationService";
import { getInterviewCount } from "../services/interviewService";
import { getFinanceStats } from "../services/transactionService";

const Overview = () => {
  const currentDate = new Date().toLocaleString("en-US", {
    month: "short",
    year: "numeric",
  });

  const { data: users, isLoading: loadingUsers } = useQuery({
    queryKey: ["users"],
    queryFn: getUserCount,
  });

  const { data: posts, isLoading: loadingPosts } = useQuery({
    queryKey: ["posts"],
    queryFn: getPostCount,
  });

  const { data: applicationCount, isLoading: loadingApplications } = useQuery({
    queryKey: ["applicationsCount"],
    queryFn: getApplicationCount,
  });

  const { data: interviewsCount, isLoading: loadingInterviews } = useQuery({
    queryKey: ["interviewsCount"],
    queryFn: getInterviewCount,
  });

  const { data: financeStats, isLoading: loadingFinance } = useQuery({
    queryKey: ["financeStats"],
    queryFn: getFinanceStats,
  });

  const data = [
    {
      type: "users",
      date: currentDate,
      value: loadingUsers ? 0 : users?.totalUsers ?? 0,
    },
    {
      type: "posts",
      date: currentDate,
      value: loadingPosts ? 0 : posts?.totalPosts ?? 0,
    },
    {
      type: "applications",
      date: currentDate,
      value: loadingApplications ? 0 : applicationCount ?? 0,
    },
    {
      type: "interviews",
      date: currentDate,
      value: loadingInterviews ? 0 : interviewsCount ?? 0,
    },
  ];
  return (
    <div className="px-2 py-4 md:px-4 md:py-0">
      <div className="flex flex-col space-y-4 lg:flex-row lg:space-x-4 lg:space-y-0">
        <div className="w-full lg:w-3/4 flex flex-col space-y-4">
          {/* OVERVIEW CARDS */}
          <div className="w-full grid grid-cols-2 lg:grid-cols-4 gap-4">
            {data.map((c, index) => (
              <OverviewCard
                key={index}
                type={c.type}
                count={c.value}
                date={c.date}
              />
            ))}
          </div>
          {/* MIDDLE CHART */}
          <div className="flex flex-col space-y-4 md:space-y-0 md:flex-row md:justify-between md:space-x-4">
            <div className="md:w-1/3 h-[450px]">
              <CountChart />
            </div>
            <div className="md:w-2/3 h-[450px] -z-10">
              <WeeklyPostChart weeklyPosts={posts?.weeklyPosts ?? []} />
            </div>
          </div>
          {/* BOTTOM CHART */}
          <div className="h-[500px]">
            <FinanceChart data={financeStats?.yearlyFinance ?? []} />
          </div>
        </div>

        <div className="lg:w-1/4">
          <Activity />
        </div>
      </div>
    </div>
  );
};

export default Overview;
